// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_FABRIC_INWARD_REQUEST = 'FETCH_FABRIC_INWARD_REQUEST';
export const FETCH_FABRIC_INWARD_SUCCESS = 'FETCH_FABRIC_INWARD_SUCCESS';
export const FETCH_FABRIC_INWARD_FAILURE = 'FETCH_FABRIC_INWARD_FAILURE';

export const FETCH_PENDING_FABRIC_PO_IN_INWARD_REQUEST = 'FETCH_PENDING_FABRIC_PO_IN_INWARD_REQUEST';
export const FETCH_PENDING_FABRIC_PO_IN_INWARD_SUCCESS = 'FETCH_PENDING_FABRIC_PO_IN_INWARD_SUCCESS';
export const FETCH_PENDING_FABRIC_PO_IN_INWARD_FAILURE = 'FETCH_PENDING_FABRIC_PO_IN_INWARD_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_FABRIC_INWARD_REQUEST = 'CREATE_FABRIC_INWARD_REQUEST';
export const CREATE_FABRIC_INWARD_SUCCESS = 'CREATE_FABRIC_INWARD_SUCCESS';
export const CREATE_FABRIC_INWARD_FAILURE = 'CREATE_FABRIC_INWARD_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_FABRIC_INWARD = 'CREATE_USER_FORM_FABRIC_INWARD';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_FABRIC_INWARD_REQUEST = 'UPDATE_FABRIC_INWARD_REQUEST';
export const UPDATE_FABRIC_INWARD_SUCCESS = 'UPDATE_FABRIC_INWARD_SUCCESS';
export const UPDATE_FABRIC_INWARD_FAILURE = 'UPDATE_FABRIC_INWARD_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_FABRIC_INWARD_REQUEST = 'FETCH_SINGLE_FABRIC_INWARD_REQUEST';
export const FETCH_SINGLE_FABRIC_INWARD_SUCCESS = 'FETCH_SINGLE_FABRIC_INWARD_SUCCESS';
export const FETCH_SINGLE_FABRIC_INWARD_FAILURE = 'FETCH_SINGLE_FABRIC_INWARD_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_FABRIC_INWARD_REQUEST = 'DELETE_FABRIC_INWARD_REQUEST';
export const DELETE_FABRIC_INWARD_SUCCESS = 'DELETE_FABRIC_INWARD_SUCCESS';
export const DELETE_FABRIC_INWARD_FAILURE = 'DELETE_FABRIC_INWARD_FAILURE';

// USERFORM RESET

export const FABRIC_INWARD_USERFORM_RESET = 'FABRIC_INWARD_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_FABRIC_INWARD_DETAILS = 'NAVIGATE_FABRIC_INWARD_DETAILS';
// navigate to company component
export const NAVIGATE_FABRIC_INWARD = 'NAVIGATE_FABRIC_INWARD';

export const RESET_FORM_DATA_WITHOUT_FABRIC_INWARD_ID = 'RESET_FORM_DATA_WITHOUT_FABRIC_INWARD_ID';
export const SET_ACTIVE_KEY_FABRIC_INWARD = 'SET_ACTIVE_KEY_FABRIC_INWARD';

export const SET_PENDING_GRID_NAME_FABRIC_INWARD = 'SET_PENDING_GRID_NAME_FABRIC_INWARD';
export const SET_UNIT_NAME_FABRIC_INWARD = 'SET_UNIT_NAME_FABRIC_INWARD';
export const SET_START_DATE_FABRIC_INWARD = 'SET_START_DATE_FABRIC_INWARD';
export const SET_END_DATE_FABRIC_INWARD = 'SET_END_DATE_FABRIC_INWARD';
